import * as fromDatatype from "../datatype-library/index";

export interface bl_pgw_monthly_merchant_txn_summary_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  rate_card_line_guid: fromDatatype.GuidDataFieldInterface;
  contract_rate_guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  vat_charge: fromDatatype.NumericDatatypeInterface;
  unrecoverable_charge: fromDatatype.NumericDatatypeInterface;
  charges_01_name: fromDatatype.VarcharDatatypeClass;
  charges_01_amount: fromDatatype.NumericDatatypeInterface;
  charges_01_pct: fromDatatype.NumericDatatypeInterface;
  charges_02_name: fromDatatype.VarcharDatatypeClass;
  charges_02_amount: fromDatatype.NumericDatatypeInterface;
  charges_02_pct: fromDatatype.NumericDatatypeInterface;
  charges_03_name: fromDatatype.VarcharDatatypeClass;
  charges_03_amount: fromDatatype.NumericDatatypeInterface;
  charges_03_pct: fromDatatype.NumericDatatypeInterface;
  charges_04_name: fromDatatype.VarcharDatatypeClass;
  charges_04_amount: fromDatatype.NumericDatatypeInterface;
  charges_04_pct: fromDatatype.NumericDatatypeInterface;
  number_of_txn: fromDatatype.IntegerDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_tax: fromDatatype.NumericDatatypeInterface;
  pgw_charges_01_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_01_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_01_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_02_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_02_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_02_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_03_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_03_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_03_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_04_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_04_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_04_pct: fromDatatype.NumericDatatypeInterface;
}

export class bl_pgw_monthly_merchant_txn_summary_report_line_RowClass
  implements bl_pgw_monthly_merchant_txn_summary_report_line_RowInterface
{
  charges_01_name: fromDatatype.VarcharDatatypeClass;
  charges_02_name: fromDatatype.VarcharDatatypeClass;
  charges_03_name: fromDatatype.VarcharDatatypeClass;
  charges_04_name: fromDatatype.VarcharDatatypeClass;
  payment_channel_tax: fromDatatype.NumericDatatypeInterface;
  pgw_charges_01_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_01_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_01_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_02_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_02_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_02_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_03_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_03_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_03_pct: fromDatatype.NumericDatatypeInterface;
  pgw_charges_04_name: fromDatatype.VarcharDatatypeInterface;
  pgw_charges_04_amount: fromDatatype.NumericDatatypeInterface;
  pgw_charges_04_pct: fromDatatype.NumericDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  rate_card_line_guid: fromDatatype.GuidDataFieldInterface;
  contract_rate_guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  vat_charge: fromDatatype.NumericDatatypeInterface;
  unrecoverable_charge: fromDatatype.NumericDatatypeInterface;
  charges_01_amount: fromDatatype.NumericDatatypeInterface;
  charges_01_pct: fromDatatype.NumericDatatypeInterface;
  charges_02_amount: fromDatatype.NumericDatatypeInterface;
  charges_02_pct: fromDatatype.NumericDatatypeInterface;
  charges_03_amount: fromDatatype.NumericDatatypeInterface;
  charges_03_pct: fromDatatype.NumericDatatypeInterface;
  charges_04_amount: fromDatatype.NumericDatatypeInterface;
  charges_04_pct: fromDatatype.NumericDatatypeInterface;
  number_of_txn: fromDatatype.IntegerDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
